import { SavedReplyCard as Card, formatAge, formatDateTime } from "@omnabase/ui";
import type { ReplyDraft } from "@omnabase/shared";
import { cleanDraftHtml } from "../../lib/draftHtml";
import { keptDraftWords } from "./useReplyDraft";

/** The person's saved reply as the kit's card at the thread's end, where the AI's draft card sits (the queue-and-chat-column round,
 *  2026-11-03, part five; the founder's fourth screenshot): the head "Your draft · 2 h ago" with the exact time on hover, "Files were not
 *  kept" when files had been attached, the stored words through the card's allow-list, and "Edit reply" (R) and "Discard". It replaces the
 *  line that stood above the box. */
export function SavedReplyCard({ saved, onEdit, onDiscard }: { saved: ReplyDraft; onEdit: () => void; onDiscard: () => void }) {
  return (
    <Card head={keptDraftWords(formatAge(saved.updatedAt))} title={formatDateTime(saved.updatedAt)} filesNote={saved.hadFiles} onEdit={onEdit} onDiscard={onDiscard}>
      <div dangerouslySetInnerHTML={{ __html: cleanDraftHtml(saved.html) }} />
    </Card>
  );
}
